export default __webpack_public_path__ + "static/media/leads-white.6bb3c678.svg";